<template>
    <DnButton
        class="base-button"
        :class="{
            'base-button--icon-left': !!iconLeft,
            'base-button--icon-right': !!iconRight,
            'base-button--disabled': !!loading,
            'base-button--loading': !!loading
        }"
        :disabled="loading ? true : null"
    >
        <BaseIcon v-if="iconLeft && !loading" :icon="iconLeft" />
        <slot />
        <BaseIcon v-if="iconRight && !loading" :icon="iconRight" />

        <template v-if="loading">
            <BaseSpinner />
        </template>
    </DnButton>
</template>

<script setup>
import DnButton from '@digitalnatives/button';

defineProps({
    iconLeft: {
        type: String,
        required: false,
        default: null
    },
    iconRight: {
        type: String,
        required: false,
        default: null
    },
    loading: {
        type: Boolean,
        required: false,
        default: false
    }
});
</script>

<style src="./BaseButton.less" lang="less"></style>
